import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

export const RedxApi = createApi({
  reducerPath: "RedxApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Redx"],
  endpoints: (builder) => ({
    // ✅ Create RedX Order
    createRedxOrder: builder.mutation<any, any>({
      query: (orderData) => ({
        url: "/redx/create-order",
        method: "POST",
        body: orderData,
      }),
      invalidatesTags: ["Redx"],
    }),

    // ✅ Track RedX Order by Tracking ID
    trackRedxOrder: builder.query<any, string>({
      query: (trackingId) => `/redx/track/${trackingId}`,
      providesTags: ["Redx"],
    }),

    // ✅ Cancel RedX Order
    cancelRedxOrder: builder.mutation<any, string>({
      query: (trackingId) => ({
        url: `/redx/cancel/${trackingId}`,
        method: "POST",
      }),
      invalidatesTags: ["Redx"],
    }),

    // ✅ Get All Completed RedX Orders
    completedRedxOrders: builder.query<any, void>({
      query: () => `/redx/completed-orders`,
      providesTags: ["Redx"],
    }),
  }),
});

export const {
  useCreateRedxOrderMutation,
  useTrackRedxOrderQuery,
  useCancelRedxOrderMutation,
  useCompletedRedxOrdersQuery,
} = RedxApi;

export default RedxApi;
